// import { i18n } from '@/common/utils/i18n'
export default {
  // 我的新增list
  inProcessList: {},
  successList: {},
  failedList: {},
  // 品类list
  categoryList: [],
  platformList: [],
  // 销售姓名面包屑
  breadCrumbList: [],
  // 销售姓名列表数据
  salesNameData: {},
  // 商机详情，以id为key
  details: {},
  // 诊断数据
  diagnosis: {},
  // 首页门店列表我负责的
  homeList: {},
  // 首页门店列表全部
  homeListAll: {},
  // 首页门店列表全部
  homeListPriority: {},
  // 销售姓名选中数量
  salesNameNum: 0,
  strategyTagData: [],
  // 首页列表筛选条件
  homeFilter: {
    status: [],
    rank: [],
    shopLayerLevel: [],
    qualityTags: [],
    bizStatus: [],
    potential: [],
    rPerformance: [],
    // abnormalTags: [0],
    isHigherPrice: undefined // 默认展示正常门店
  },
  // 门店列表的页数
  homeListPageNo: 1,
  // 门店列表的页数
  homeListAllPageNo: 1,
  // 门店列表的页数
  homeListPriorityPageNo: 1,
  // 门店筛选项 已选择条件的数量
  selectNumstatus: '', // 签约状态
  selectNumcombine: '', // 门店价值
  selectNumother: '', // 其他筛选项
  isFromGiveUp: false, // 用于详情页面判断是否重新刷新数据
  activeTab: 2, // 商机门店 选中的 tab 2：我负责的 1：全部
  // 以下是框架重构的属性
  newStoreActiveTab: 3, // 商机门店 选中的 'myStore';'myStore': 我负责的 ; allStore：全部
  storeListFilter: {
    status: [],
    rank: [],
    type: 0, // 门店类型
    shopLayerLevel: [], // 商户运营价值
    qualityTags: [],
    bizStatus: [],
    potential: [],
    rPerformance: [],
    // 排序
    sortType: 0,
    // 诊断分数
    diagnosisScoreStart: 0,
    diagnosisScoreEnd: 100,
    diagnosisScoreFlag: 0,
    // 业务策略标签
    arrStrategyTag: [],
    isHigherPrice: undefined // 默认展示正常门店
  },
  changeZIndex: false,
  changeHistory: {}, // 搜索历史 type 1 sug推荐 2 搜索结果
  firstEnterList: true
}
